var Size = /** @class */ (function () {
    function Size(width, height) {
        this.width = width;
        this.height = height;
    }
    Size.prototype.isReal = function () {
        return isFinite(this.width) && isFinite(this.height);
    };
    Size.prototype.toString = function () {
        return this.width + " " + this.height;
    };
    return Size;
}());
export { Size };
